<template>
  <keep-alive>
    <b-modal
        ref="modal"
        v-bind="$attrs"
        :id="id"
        :title="modalTitle"
        @ok="handleOk"
        title-class="font-18"
        no-close-on-backdrop
    >
      <validation-observer ref="form_observer" v-if="!loading">
        <component
            :is="form"
            v-bind="formProps"
            v-on="formListeners"
            v-model="model"
            :is-valid.sync="isValid"
            :errors="errors"
            ref="form"
            is-modal="true"
        >
        </component>
      </validation-observer>
      <div v-if="loading" class="d-flex">
        <i class="bx bx-loader bx-spin font-size-16 align-middle mx-auto"></i>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button
            size="md"
            variant="primary"
            @click="ok()"
            :disabled="updating || loading"
        >
          <i
              v-if="updating"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
  </keep-alive>
</template>

<script>
import ModelEditModal from "./modal-edit";
import FormsModel from "@/components/forms/feed.vue";

export default {
  extends: ModelEditModal,
  props: {
    id: {type: String, required: true},
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t("feed_products.singular"));
      },
    },
    resourceRoute: {default: "models"},
    modelVariable: {default: "model"},
    form: {
      type: Object,
      default: function () {
        return FormsModel;
      },
    },
    formProps: {
      type: Object,
      default: function () {
        return {};
      },
    },
    formListeners: {
      type: Object,
      default: function () {
        return {};
      },
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isValid: true,
      updating: false,
      model: {
        ...this.initialValue,
      },
      errors: {},
    };
  },
  methods: {
    async fetchModel(id) {
      try {
        this.loading = true;
        const response = await this.$axios.get(`/v1/feed_products/${id}`);
        const {
          data: {data},
        } = response;
        this.$set(this, 'model', data)

        return response;
      } catch (error) {
        this.failedAlert(error);
      } finally {
        this.loading = false;
      }
    },
    update(value) {
      let data = value
      if (!Number.isInteger(data.manufacture_id)) {
        data.manufacture_id = null
      }

      return this.$axios.put(`/v1/feed_products/${data.id}`, data);
    },
    delete() {
      // return this.$axios.delete(`/customers/${value.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084f3;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6c7589;
  }
}
</style>
  